module.exports = __webpack_public_path__ + "img/logo-gigawhat.399102e4.svg";